<template>
    <div class="flex">
        {{item.admin_name}} [{{item.group.title}}]
    </div>
</template>
<script>
    export default {

        props: {
            value: {},
            item: {
                default() {
                    return {};
                }
            }
        },
        data() {
            return {
            }
        },
        created() {
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
    @import "index.scss";
</style>